function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 61931",
  d: "M22.42 17c0-3.5-2.355-5.915-6.346-5.915h-5.519l-2.03.1 1.538-1.3L12.295 7.7a.9.9 0 0 0 .29-.677.911.911 0 0 0-.958-.949 1.078 1.078 0 0 0-.712.3l-5.036 4.969a1.008 1.008 0 0 0 0 1.45l5.036 4.966a1.078 1.078 0 0 0 .712.3.945.945 0 0 0 .668-1.626l-2.232-2.18-1.539-1.293 2.03.088h5.564c2.813 0 4.368 1.6 4.368 3.885s-1.556 3.955-4.368 3.955h-2.057a.976.976 0 1 0 .009 1.951h2.118c3.92 0 6.232-2.312 6.232-5.839z",
  transform: "translate(-5.571 -6.078)"
});

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.849 16.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.aea5040f.svg";
export { ForwardRef as ReactComponent };